var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPort = function SvgPort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19 13.001h-2.031a.97.97 0 0 0-.97.97v.024c0 .557.45 1.006 1.001 1.006h.91A6.01 6.01 0 0 1 13 19.912V9.86c1.864-.485 3.21-2.266 2.973-4.33a4.014 4.014 0 0 0-3.509-3.503 4.005 4.005 0 0 0-4.463 3.976c0 1.857 1.279 3.41 3 3.857v10.053a6.01 6.01 0 0 1-4.91-4.911H7a1.002 1.002 0 0 0 0-2.002H4.48a.48.48 0 0 0-.48.48v.374c0 4.132 3.36 7.871 7.483 8.13C16.127 22.278 20 18.584 20 14v-.521a.48.48 0 0 0-.48-.48h-.518zM10 6c0-1.104.897-2 1.999-2 1.101 0 1.999.898 1.999 2s-.898 2-2 2c-1.1 0-1.998-.896-1.998-2"
  })));
};
export default SvgPort;